/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutSidebarFilled = createReactComponent("filled", "layout-sidebar-filled", "IconLayoutSidebarFilled", [["path", { "d": "M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3zm12 -16h-8v14h8a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

export { IconLayoutSidebarFilled as default };
//# sourceMappingURL=IconLayoutSidebarFilled.mjs.map
